// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2365116a] .current-location-cell,[data-v-2365116a] .next-location-cell{width:1000px}", ""]);
// Exports
module.exports = exports;
